import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import GeneralApiLoading from "../general/GeneralApiLoading";
import * as theme from "../theme";
import background from "../logos/common/background.png";
import humancommon from "../logos/common/humancommon.png";
import _ from "lodash";

import {
  changeShowActualSTIpdfAndReadyPages,
  changeShowNavigationBar,
  getBrokerDetails,
  getClientDetails,
  getDataForSTIpdfReady,
  getDocFromComponents,
  getFormGroupNodesArray,
  getFormstateFromComponents,
  getLanguageCode,
  getPagesProperties,
  getShowActualSTIpdf,
  getUserDetails,
  updateFormstateSize,
} from "../store/components";
import { QuoteyBrandForPDF } from "../general/QuoteyBrand";
import {
  Client_Address,
  Client_Business_name,
  Client_Contact,
  Client_Email,
  Client_Name,
} from "../store/permanentQues";
import { getAddressInFormattedForm } from "../store/businesslogic/hwlHelper";
import {
  ADDRESS,
  CONTACT,
  CURRENCY,
  DATE,
  EMAIL,
  LARGESTRING,
  MULTISELECT,
  MULTISELECTPLATINUM,
  NUMBER,
  PERCENTAGE,
  PossibleArrayTypesForFormGroupNodeArray,
  PossibleScheduleInputType,
  SCHEDULE,
  SIMPLESTRING,
  SINGLESELECT,
  SINGLESELECTPLATINUM,
  YEAR,
  YESNO,
} from "../store/businesslogic/hardwiredlogic";
import { formatter } from "../general/Price";
import moment from "moment";

const StipdfReady = () => {
  const { search } = useLocation();
  const dispatch = useDispatch();
  const showActualSTIpdf = useSelector(getShowActualSTIpdf);
  const doc = useSelector(getDocFromComponents);
  const formGroupNodesArray = useSelector(getFormGroupNodesArray);
  const clientDetails = useSelector(getClientDetails);
  const languagecode = useSelector(getLanguageCode);

  const encryptedProspectId = search.substring(4);

  useEffect(() => {
    dispatch(changeShowNavigationBar({ value: false }));
    dispatch(getDataForSTIpdfReady({ id: encryptedProspectId }));
  }, [dispatch, encryptedProspectId]);

  return (
    <GeneralApiLoading possibleApiValue={doc}>
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            width: `${theme.SCALES.pdfWidth}px`,
          }}
        >
          {showActualSTIpdf ? (
            <TemplateA1
              clientDetails={clientDetails}
              languagecode={languagecode}
              formGroupNodesArray={formGroupNodesArray}
            ></TemplateA1>
          ) : (
            <CalculateDivSizesForAllFormsGroupsAndQuestions
              formGroupNodesArray={formGroupNodesArray}
              languagecode={languagecode}
              allRowComponents={true}
            ></CalculateDivSizesForAllFormsGroupsAndQuestions>
          )}
        </div>
      </div>
    </GeneralApiLoading>
  );
};

const TemplateA1 = ({ clientDetails, languagecode, formGroupNodesArray }) => {
  return (
    <>
      <FirstPage clientDetails={clientDetails}></FirstPage>
      <QuestionAndAnswerPages
        clientDetails={clientDetails}
        languagecode={languagecode}
        formGroupNodesArray={formGroupNodesArray}
      ></QuestionAndAnswerPages>
    </>
  );
};

const QuestionAndAnswerPages = ({
  clientDetails,
  formGroupNodesArray,
  languagecode,
}) => {
  const pages = useSelector(getPagesProperties);

  const convertPagesToMappableArray = (pages) => {
    let array = [];

    for (let pagenumber in pages) {
      array.push({ ...pages[pagenumber], pagenumber });
    }
    console.log("This is the size of the array ", array.length, array);
    return array;
  };

  const totalpages = Object.keys(pages).length;

  return (
    <>
      {convertPagesToMappableArray(pages).map((item, index) => (
        <QuestionAndAnswerPage
          pageProperty={item}
          key={index}
          totalpages={totalpages}
          clientDetails={clientDetails}
          formGroupNodesArray={formGroupNodesArray}
          languagecode={languagecode}
        ></QuestionAndAnswerPage>
      ))}
    </>
  );
};

const QuestionAndAnswerPage = ({
  pageProperty,
  formGroupNodesArray,
  totalpages,
  clientDetails,
  languagecode,
}) => {
  return (
    <div
      style={{
        width: "100%",
        height: `${theme.SCALES.pdfHeight}px`,
        display: "flex",
        flexDirection: "column",
      }}
    >
      <HeaderForEveryPage clientDetails={clientDetails}></HeaderForEveryPage>
      <RemainingSpaceBetweenHeaderAndFooter
        pageProperty={pageProperty}
        formGroupNodesArray={formGroupNodesArray}
        languagecode={languagecode}
      ></RemainingSpaceBetweenHeaderAndFooter>
      <FooterForEveryPage
        pagenumber={pageProperty.pagenumber}
        totalpages={totalpages}
      ></FooterForEveryPage>
    </div>
  );
};

const RemainingSpaceBetweenHeaderAndFooter = ({
  pageProperty,
  formGroupNodesArray,
  languagecode,
}) => {
  return (
    <div
      style={{
        width: "100%",
        height: `${calculateAvailablePageSize()}px`,
      }}
    >
      <CalculateDivSizesForAllFormsGroupsAndQuestions
        formGroupNodesArray={formGroupNodesArray}
        languagecode={languagecode}
        allRowComponents={false}
        pageProperty={pageProperty}
      ></CalculateDivSizesForAllFormsGroupsAndQuestions>
    </div>
  );
};

const HeaderForEveryPage = ({ clientDetails }) => {
  const clientName = clientDetails[Client_Name];
  const clientBusinsessName = clientDetails[Client_Business_name];
  const clientAddress = clientDetails[Client_Address];
  const clientContact = clientDetails[Client_Contact];
  const clientEmail = clientDetails[Client_Email];
  const bottomPadding = "10%";
  return (
    <div
      style={{
        width: "100%",
        height: `${theme.SCALES.pdfTemplateA1HeaderHeight}px`,
        overflow: "hidden",
        lineHeight: 1.3,
        // border: `10px solid ${theme.COLORS.primary_navyblue}`,
        // borderBottom: 0,
      }}
    >
      <div
        style={{
          width: "100%",
          height: `calc(100% - ${bottomPadding})`,
          display: "flex",
          justifyContent: "space-between",
          fontFamily: "GibsonRegular",
          color: theme.COLORS.primary_navyblue,
          alignItems: "center",
          paddingLeft: `${theme.SCALES.pdfTemplateA1leftrightMargin}%`,
          paddingRight: `${theme.SCALES.pdfTemplateA1leftrightMargin}%`,
          paddingBottom: "15px",
          backgroundColor: theme.COLORS.tertiary_lightbackground,
        }}
      >
        <div
          style={{
            width: "50%",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "start",

            letterSpacing: 1,
          }}
        >
          <div
            style={{
              width: "100%",
              fontSize: "190%",
              fontWeight: "bold",
              fontFamily: "GibsonSemiBd",
            }}
          >
            {clientName}
          </div>
          <div>{clientBusinsessName}</div>
        </div>
        <div
          style={{
            width: "50%",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "end",
          }}
        >
          <div
            style={{
              width: "45%",
              height: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "end",
              fontSize: "80%",
              letterSpacing: 1,
            }}
          >
            <div style={{ fontFamily: "GibsonLight", textAlign: "right" }}>
              {getAddressInFormattedForm({
                node: { answer: clientAddress, type: "address" },
              })}
            </div>
            <div style={{ fontFamily: "GibsonLight", textAlign: "right" }}>
              {clientContact}
            </div>
            <div style={{ fontFamily: "GibsonLight", textAlign: "right" }}>
              {clientEmail}
            </div>
          </div>
        </div>
      </div>
      <div style={{ width: "100%", height: bottomPadding }}></div>
    </div>
  );
};

const FooterForEveryPage = ({ pagenumber, totalpages }) => {
  const leftRightPadding = `${theme.SCALES.pdfTemplateA1leftrightMargin}%`;
  let donotshowpagenumber = false;
  if (!pagenumber && !totalpages) donotshowpagenumber = true;

  return (
    <div
      style={{
        width: "100%",
        height: `${theme.SCALES.pdfTemplateA1FooterHeight}px`,
        backgroundColor: theme.COLORS.primary_navyblue,
        fontFamily: "GibsonLight",
      }}
    >
      <div
        style={{
          width: "100%",
          height: "100%",
          paddingLeft: leftRightPadding,
          paddingRight: leftRightPadding,
          color: "white",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <div style={{ letterSpacing: 1 }}>
          {donotshowpagenumber ? "" : `PAGE  ${pagenumber}  OF  ${totalpages}`}
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            width: "50%",
            justifyContent: "end",
          }}
        >
          <div style={{ fontStyle: "italic", letterSpacing: 1 }}>
            {theme.QUOTEY_SLOGAN}
          </div>
          <div style={{ width: "5%" }}></div>
          <QuoteyBrandForPDF></QuoteyBrandForPDF>
        </div>
      </div>
    </div>
  );
};

const FirstPage = ({ clientDetails }) => {
  const userdetails = useSelector(getUserDetails);
  const brokerdetails = useSelector(getBrokerDetails);
  const brokeragecode = brokerdetails.brokerages[0].code;
  const brokername = brokerdetails.firstname + " " + brokerdetails.lastname;
  const brokeragename = brokerdetails.brokerages[0].name;
  const brokercontact = brokerdetails.phonenumber;
  const brokeremail = userdetails.email;
  const sectionHeight = {
    date: "8%",
    submissionAndBussName: "19%",
    genonQuoteyio: "10%",
    firstpara: "18%",
    secondpara: "9%",
    brokerinfo: "29%",
    spaceleft: "",
  };
  sectionHeight.spaceleft = `calc(100% - ${sectionHeight.date}- ${sectionHeight.submissionAndBussName}- ${sectionHeight.genonQuoteyio}- ${sectionHeight.firstpara}- ${sectionHeight.secondpara}- ${sectionHeight.brokerinfo})`;
  const paddingLeftRight = `${theme.SCALES.pdfTemplateA1leftrightMargin}%`;
  return (
    <div
      style={{
        width: "100%",
        height: `${theme.SCALES.pdfHeight}px`,
        backgroundImage: `url(${background})`,
        backgroundSize: "contain",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div
        style={{
          width: "100%",
          height: `calc(100% - ${theme.SCALES.pdfTemplateA1FooterHeight}px)`,
          paddingLeft: paddingLeftRight,
          paddingRight: paddingLeftRight,
          fontFamily: "GibsonRegular",
          letterSpacing: 1,
          lineHeight: 1,
          color: theme.COLORS.primary_navyblue,
        }}
      >
        <div
          style={{
            width: "100%",
            height: sectionHeight.date,
            display: "flex",
            alignItems: "end",
            justifyContent: "end",
            fontSize: "150%",
          }}
        >
          {moment(new Date(), "DD/MM/YYYY")
            .format("MMM DD, YYYY")
            .toUpperCase()}
        </div>
        <div
          style={{
            width: "100%",
            height: sectionHeight.submissionAndBussName,
            display: "flex",
            alignItems: "start",
            justifyContent: "end",
            flexDirection: "column",
          }}
        >
          <div
            style={{
              fontSize: "200%",
            }}
          >
            Submission for Insurance
          </div>
          <div style={{ width: "100%", height: "7%" }}></div>
          <div style={{ fontSize: "400%", fontFamily: "GibsonSemiBd" }}>
            {clientDetails[Client_Business_name]}
          </div>
        </div>
        <div
          style={{
            width: "100%",
            height: sectionHeight.genonQuoteyio,
            display: "flex",
            alignItems: "end",
            justifyContent: "start",
            fontSize: "220%",
            fontFamily: "GibsonRegular",
            fontWeight: "bold",
            color: theme.COLORS.secondary_skyblue,
          }}
        >
          Generated on Quotey.io
        </div>
        <div
          style={{
            width: "100%",
            height: sectionHeight.firstpara,
            display: "flex",
            alignItems: "end",
            justifyContent: "end",
            fontSize: "150%",
            fontFamily: "GibsonRegular",
            fontWeight: "bold",
            color: "black",
            textAlign: "right",
            lineHeight: "1.2",
          }}
        >
          <div style={{ width: "15%" }}></div>
          <div style={{ width: "85%" }}>
            Please find attached a competed application for your consideration.
            We look forward to hearing from you in due course and are on hand to
            answer any additional questions you may have.
          </div>
        </div>
        <div
          style={{
            width: "100%",
            height: sectionHeight.secondpara,
            display: "flex",
            alignItems: "end",
            justifyContent: "end",
            fontSize: "150%",
            fontFamily: "GibsonRegular",
            color: "black",
            textAlign: "right",
            lineHeight: "1.2",
          }}
        >
          <div style={{ width: "15%" }}></div>
          <div style={{ width: "85%" }}>
            Our client has been sent a similar version of this application for
            their review and signature. A signed version will be available in
            due course and on demand in the case of binding.
          </div>
        </div>
        <div
          style={{
            width: "100%",
            height: sectionHeight.brokerinfo,
            display: "flex",
            alignItems: "end",
            fontSize: "150%",
            fontFamily: "GibsonRegular",
            color: "black",
            textAlign: "right",
            lineHeight: "1.2",
          }}
        >
          <div
            style={{
              width: "50%",
              height: "100%",
              display: "flex",
              alignItems: "end",
              justifyContent: "left",
            }}
          >
            <img
              style={{
                height: theme.SCALES.brokerageLogoHeight,
                width: theme.SCALES.brokerageLogoWidth,
              }}
              src={
                process.env.REACT_APP_BASICSERVICE +
                "/static/media/brokerageslogo/" +
                brokeragecode +
                ".png"
              }
              alt={""}
            />
          </div>
          <div
            style={{
              width: "50%",
              height: "100%",
              display: "flex",
              alignItems: "end",
              justifyContent: "right",
            }}
          >
            <div
              style={{
                width: "100%",
                height: "40%",
                display: "flex",
                alignItems: "center",
                justifyContent: "left",
              }}
            >
              <img
                style={{
                  width: "150px",
                  height: "150px",
                }}
                src={humancommon}
                alt={""}
              />
              <div
                style={{
                  height: "100%",
                  width: "5%",
                  backgroundColor: "white",
                }}
              ></div>
              <div
                style={{
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "left",
                  justifyContent: "center",
                  textAlign: "left",
                  lineHeight: "1.2",
                  color: theme.COLORS.primary_navyblue,
                }}
              >
                <div
                  style={{
                    color: theme.COLORS.primary_navyblue,
                    fontFamily: "GibsonSemiBd",
                  }}
                >
                  Prepared by
                </div>
                <div style={{ textAlign: "left" }}>{brokername}</div>
                <div>{brokeragename}</div>
                <div>{brokercontact}</div>
                <div>{brokeremail}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <FooterForEveryPage></FooterForEveryPage>
    </div>
  );
};

const CalculateDivSizesForAllFormsGroupsAndQuestions = ({
  formGroupNodesArray,
  languagecode,
  allRowComponents,
  pageProperty,
}) => {
  const slicingFormGroupNodesArrayAsPerReq = ({
    formGroupNodesArray,
    allRowComponents,
    pageProperty,
  }) => {
    if (allRowComponents) return formGroupNodesArray;

    let { start, end } = pageProperty;

    if (!isNaN(start) && !isNaN(end))
      return formGroupNodesArray.slice(start, end + 1);

    return [];
  };

  return (
    <>
      {slicingFormGroupNodesArrayAsPerReq({
        formGroupNodesArray,
        allRowComponents,
        pageProperty,
      }).map((item, index) => (
        <EachComponentsToCalculate
          item={item}
          index={index}
          key={index}
          languagecode={languagecode}
        ></EachComponentsToCalculate>
      ))}
      {/* AFTER REGISTERING ALL THE SIZE OF EACH FORM NODE GROUP, SHOW THE ORIGINAL PAGES */}
      {allRowComponents ? (
        <MakeShowActualSTIpdfTrue></MakeShowActualSTIpdfTrue>
      ) : null}
    </>
  );
};

const calculateAvailablePageSize = () => {
  return (
    theme.SCALES.pdfHeight -
    theme.SCALES.pdfTemplateA1HeaderHeight -
    theme.SCALES.pdfTemplateA1FooterHeight
  );
};

const MakeShowActualSTIpdfTrue = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      changeShowActualSTIpdfAndReadyPages({
        value: true,
        availablePageSize: calculateAvailablePageSize(),
      })
    );
  });
  return null;
};

const EachComponentsToCalculate = ({ item, index, languagecode }) => {
  // let { type, text, node } = item;
  // if (type === PossibleArrayTypesForFormGroupNodeArray.form)
  //   return <FormDiv item={item}></FormDiv>;
  // if (type === PossibleArrayTypesForFormGroupNodeArray.location)
  //   return <div style={{ width: "100%", height: "130px" }}>{text}</div>;
  //   if (type === PossibleArrayTypesForFormGroupNodeArray.locationgroup)
  //   return <div style={{ width: "100%", height: "130px" }}>{text}</div>;
  // if (type === PossibleArrayTypesForFormGroupNodeArray.group)
  //   return <div style={{ width: "100%", height: "70px" }}>{text.en}</div>;
  // if (type === PossibleArrayTypesForFormGroupNodeArray.node)
  //   return <div style={{ width: "100%", height: "25px" }}>{node.text.en}</div>;

  // return null;
  let { text, formstateAddress, type } = item;

  const myDiv = useRef(null);
  const dispatch = useDispatch();
  useEffect(() => {
    let { scrollHeight } = myDiv.current;
    dispatch(
      updateFormstateSize({ type, formstateAddress, scrollHeight, index })
    );
  });
  return (
    <div
      ref={myDiv}
      style={{
        width: "100%",
        paddingRight: `${theme.SCALES.pdfTemplateA1leftrightMargin}%`,
        paddingLeft: `${theme.SCALES.pdfTemplateA1leftrightMargin}%`,
      }}
    >
      <ReturnAsPerRowTypes
        item={item}
        languagecode={languagecode}
        index={index}
      ></ReturnAsPerRowTypes>
    </div>
  );
};

const ReturnAsPerRowTypes = ({ item, languagecode, index }) => {
  let { type, node } = item;
  if (type === PossibleArrayTypesForFormGroupNodeArray.form)
    return <FormDiv item={item} languagecode={languagecode}></FormDiv>;
  if (type === PossibleArrayTypesForFormGroupNodeArray.location)
    return (
      <LocaitonNumberedHeading
        item={item}
        languagecode={languagecode}
      ></LocaitonNumberedHeading>
    );
  if (type === PossibleArrayTypesForFormGroupNodeArray.locationgroup)
    return <GroupDiv item={item} languagecode={languagecode}></GroupDiv>;
  if (type === PossibleArrayTypesForFormGroupNodeArray.group)
    return <GroupDiv item={item} languagecode={languagecode}></GroupDiv>;
  if (type === PossibleArrayTypesForFormGroupNodeArray.node)
    return (
      <QuestionTextVariableAnswerRow
        item={item}
        index={index}
        languagecode={languagecode}
      ></QuestionTextVariableAnswerRow>
    );

  return null;
};

const QuestionTextVariableAnswerRow = ({ item, index, languagecode }) => {
  let { node, firstnode, lastnode, nodecount } = item;
  const minHeight = "45px";
  let { type } = node;
  let specialQuestionType = ({ type }) => {
    if (type === MULTISELECTPLATINUM || type === SCHEDULE) return true;
    return false;
  };
  return (
    <div
      style={{
        width: "100%",
        backgroundColor: nodecount % 2 === 0 ? "white" : theme.COLORS.help_tip,
        display: "flex",
        alignItems: "center",
        borderTopRightRadius: firstnode
          ? theme.SCALES.pdfRowQuestionBorderRadius
          : 0,
        borderTopLeftRadius: firstnode
          ? theme.SCALES.pdfRowQuestionBorderRadius
          : 0,
        borderBottomLeftRadius: lastnode
          ? theme.SCALES.pdfRowQuestionBorderRadius
          : 0,
        borderBottomRightRadius: lastnode
          ? theme.SCALES.pdfRowQuestionBorderRadius
          : 0,
      }}
    >
      {specialQuestionType({ type }) ? (
        <SpecialQuestionType
          node={node}
          languagecode={languagecode}
          minHeight={minHeight}
        ></SpecialQuestionType>
      ) : (
        <GeneralQuestionTypes
          node={node}
          languagecode={languagecode}
          minHeight={minHeight}
        ></GeneralQuestionTypes>
      )}
    </div>
  );
};

const GeneralQuestionTypes = ({ node, languagecode, minHeight }) => {
  return (
    <>
      <div
        style={{
          width: "49%",
          borderRight: "3px solid white",
          display: "flex",
          fontFamily: "GibsonRegular",
          fontSize: "85%",
          height: "100%",
        }}
      >
        <div
          style={{
            display: "flex",
            minHeight: minHeight,
            alignItems: "center",
            justifyContent: "start",
            width: "100%",
            paddingLeft: theme.SCALES.pdfPaddingInsideFormGroupHeading,
            paddingRight: theme.SCALES.pdfPaddingInsideFormGroupHeading,
            fontFamily: "GibsonLight",
            fontWeight: "bold",
            letterSpacing: 1,
          }}
        >
          {node.text[languagecode]}
        </div>
      </div>
      <div
        style={{ width: "1%", height: "100%", backgroundColor: "white" }}
      ></div>
      <AnswerPart node={node} languagecode={languagecode}></AnswerPart>
    </>
  );
};

const SpecialQuestionType = ({ node, languagecode, minHeight }) => {
  let { text, type, answer } = node;

  return (
    <div style={{ width: "100%", display: "flex", flexDirection: "column" }}>
      <div style={{ width: "100%", display: "flex", alignItems: "center" }}>
        <GeneralQuestionTypes
          node={node}
          languagecode={languagecode}
          minHeight={minHeight}
        ></GeneralQuestionTypes>
      </div>
      <SpecialAnswerTypeDiv type={type} node={node}></SpecialAnswerTypeDiv>
    </div>
  );
};

const SpecialAnswerTypeDiv = ({ type, node }) => {
  if (type === SCHEDULE)
    return <ScheduleAnswerShowing node={node}></ScheduleAnswerShowing>;

  if (type === MULTISELECTPLATINUM)
    return (
      <MultiSelectPlatinumAnswerShowing
        node={node}
      ></MultiSelectPlatinumAnswerShowing>
    );

  return (
    <div
      style={{
        width: "100%",
        minHeight: "50px",
        backgroundColor: "yellowgreen",
      }}
    ></div>
  );
};

const MultiSelectPlatinumAnswerShowing = ({ node }) => {
  // TODO: After deciding what to do with the table come here to edit
  return <></>;
};

const ScheduleAnswerShowing = ({ node }) => {
  // TODO: After deciding what to do with the table come here to edit

  return <></>;
};

const AnswerPart = ({ node, languagecode }) => {
  if (
    node.type === SIMPLESTRING ||
    node.type === PERCENTAGE ||
    node.type === DATE ||
    node.type === EMAIL ||
    node.type === CONTACT ||
    node.type === YEAR ||
    node.type === NUMBER ||
    node.type === LARGESTRING ||
    node.type === YESNO
  )
    return (
      <GeneralAnswerTextPropertiesDiv
        text={node.answer}
      ></GeneralAnswerTextPropertiesDiv>
    );

  if (node.type === SINGLESELECTPLATINUM || node.type === SINGLESELECT)
    return (
      <GeneralAnswerTextPropertiesDiv
        text={node.answer ? node.answer.text[languagecode] : null}
      ></GeneralAnswerTextPropertiesDiv>
    );
  if (node.type === CURRENCY)
    return (
      <GeneralAnswerTextPropertiesDiv
        text={node.answer ? formatter.format(node.answer) : null}
      ></GeneralAnswerTextPropertiesDiv>
    );

  if (node.type === ADDRESS)
    return (
      <GeneralAnswerTextPropertiesDiv
        text={getAddressInFormattedForm({ node })}
      ></GeneralAnswerTextPropertiesDiv>
    );

  if (node.type === MULTISELECT)
    return (
      <MulitSelectAnswerBullets
        node={node}
        languagecode={languagecode}
      ></MulitSelectAnswerBullets>
    );

  if (node.type === MULTISELECTPLATINUM)
    return (
      <MulitSelectAnswerBullets
        node={node}
        languagecode={languagecode}
        platunium={true}
      ></MulitSelectAnswerBullets>
    );

  if (node.type === SCHEDULE)
    return (
      <GeneralAnswerTextPropertiesDiv
        text={getMainAnswerTextForScheduleQuestion({ node })}
      ></GeneralAnswerTextPropertiesDiv>
    );

  return (
    <GeneralAnswerTextPropertiesDiv
      text={node.answer ? JSON.stringify(node.answer) : null}
    ></GeneralAnswerTextPropertiesDiv>
  );
};

const getMainAnswerTextForScheduleQuestion = ({ node }) => {
  if (!node.answer) return "";

  if (!node.answer.mainanswer) return "";

  let { inputType } = node.logic;

  if (
    inputType === PossibleScheduleInputType.number ||
    inputType === PossibleScheduleInputType.string
  ) {
    return node.answer.mainanswer;
  }
  if (inputType === PossibleScheduleInputType.currency) {
    return formatter.format(node.answer.mainanswer);
  }

  return "";
};

const GeneralAnswerTextPropertiesDiv = ({ text }) => {
  return (
    <div
      style={{
        width: "50%",
        display: "flex",
        fontFamily: "GibsonLight",
        fontSize: "85%",
        height: "100%",
        flexDirection: "column",
        letterSpacing: 1,
        wordWrap: "break-word",
      }}
    >
      {text}
    </div>
  );
};

const MulitSelectAnswerBullets = ({ node, languagecode, platunium }) => {
  const mapperVariable = ({ node, platunium }) => {
    if (platunium) {
      if (node.answer) {
        if (!_.isEmpty(node.answer.main) && Array.isArray(node.answer.main)) {
          return node.answer.main;
        }
      }
    }

    if (node.answer) {
      if (!_.isEmpty(node.answer) && Array.isArray(node.answer)) {
        return node.answer;
      }
    }

    return [];
  };

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      {mapperVariable({ node, platunium }).map((item, index) => (
        <div
          style={{
            display: "flex",
            fontFamily: "GibsonLight",
            fontSize: "85%",
            wordWrap: "break-word",
            letterSpacing: 1,
          }}
          key={index}
        >
          &bull;&nbsp;&nbsp;{item?.text ? item.text[languagecode] : ""}
        </div>
      ))}
    </div>
  );
};

const FormDiv = ({ item, languagecode }) => {
  return (
    <div
      style={{
        width: "100%",
        minHeight: "85px",
        display: "flex",
        alignItems: "center",
        justifyContent: "start",
        fontFamily: "GibsonSemiBd",
        color: theme.COLORS.secondary_skyblue,
        fontSize: "180%",
        letterSpacing: 1,
        paddingBottom: "10px",

        paddingLeft: theme.SCALES.pdfPaddingInsideFormGroupHeading,
        paddingRight: theme.SCALES.pdfPaddingInsideFormGroupHeading,
      }}
    >
      {item.text[languagecode]}
    </div>
  );
};
const GroupDiv = ({ item, languagecode }) => {
  return <div style={theme.pdfPageHeadingStyle}>{item.text[languagecode]}</div>;
};
const LocaitonNumberedHeading = ({ item, languagecode }) => {
  return (
    <div
      style={{
        width: "100%",
        minHeight: "75px",
        display: "flex",
        alignItems: "end",
        justifyContent: "start",
        fontFamily: "GibsonSemiBd",
        color: theme.COLORS.location_heading,
        fontSize: "150%",
        letterSpacing: 1,
        paddingBottom: "10px",
        paddingLeft: theme.SCALES.pdfPaddingInsideFormGroupHeading,
        paddingRight: theme.SCALES.pdfPaddingInsideFormGroupHeading,
      }}
    >
      {item.text}
    </div>
  );
};

export default StipdfReady;
